import { Field, Image, ImageField, Item, getFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';
import { ComponentProps } from 'lib/component-props';
import { RecordOfFields } from 'models/fields';
import compose from 'lib/enhancers/compose';
import withStyles from 'lib/enhancers/withStyles';
import styles from './CalloutBlock.module.scss';
import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';

type CalloutBlockFields = {
  content: Field<string>;
  image: ImageField;
  backgroundColor: Item;
};

type CalloutBlockProps = ComponentProps & {
  fields: CalloutBlockFields;
};

const CalloutBlock = (props: CalloutBlockProps): React.JSX.Element => {
  const {
    fields: { content, image, backgroundColor },
    className,
  } = props;
  const bgrndColor = backgroundColor?.fields as RecordOfFields;

  const withImage = (
    <div className={styles['icon-flex-item']}>
      <div className={styles['img-cell']}>
        <Image field={image} />
      </div>
      <div>
        <RichTextWrapper field={content} />
      </div>
    </div>
  );

  const withoutImage = <RichTextWrapper field={content} />;

  return (
    <div className={`${styles['calloutBox']} ${getFieldValue(bgrndColor, 'Value')} ${className}`}>
      {image.value?.src === undefined ? withoutImage : withImage}
    </div>
  );
};

export default compose<CalloutBlockProps>(withValidDatasourceCheck(), withStyles())(CalloutBlock);
